interface LoadingProps {
  message?: string
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

export function Loading({
  message = 'Loading...',
  size = 'md',
  className = ''
}: LoadingProps) {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12'
  }

  return (
    <div className={`flex items-center justify-center p-8 ${className}`}>
      <div className="text-center">
        <div className={`relative mx-auto ${sizeClasses[size]}`}>
          {/* Outer circle - clockwise, baby blue */}
          <div
            className={`absolute inset-0 ${sizeClasses[size]} animate-spin rounded-full border-2 border-transparent border-t-blue-300 border-r-blue-300 border-b-blue-300 dark:border-t-blue-400 dark:border-r-blue-400 dark:border-b-blue-400`}
          ></div>
          {/* Inner circle - counter-clockwise, lighter grey */}
          <div
            className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ${size === 'sm' ? 'h-2 w-2' : size === 'md' ? 'h-4 w-4' : 'h-8 w-8'} animate-spin rounded-full border-2 border-transparent border-t-gray-200 border-r-gray-200 border-b-gray-200 dark:border-t-gray-300 dark:border-r-gray-300 dark:border-b-gray-300`}
            style={{
              animationDirection: 'reverse',
              animationDuration: '0.8s'
            }}
          ></div>
        </div>
        <p className="text-muted-foreground mt-2 text-sm">{message}</p>
      </div>
    </div>
  )
}

interface InlineLoadingProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

export function InlineLoading({
  size = 'sm',
  className = ''
}: InlineLoadingProps) {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8'
  }

  return (
    <div className={`relative ${sizeClasses[size]} ${className}`}>
      {/* Outer circle - clockwise, baby blue */}
      <div
        className={`absolute inset-0 ${sizeClasses[size]} animate-spin rounded-full border-2 border-transparent border-t-blue-300 border-r-blue-300 border-b-blue-300 dark:border-t-blue-400 dark:border-r-blue-400 dark:border-b-blue-400`}
      ></div>
      {/* Inner circle - counter-clockwise, lighter grey */}
      <div
        className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ${size === 'sm' ? 'h-2 w-2' : size === 'md' ? 'h-4 w-4' : 'h-6 w-6'} animate-spin rounded-full border-2 border-transparent border-t-gray-200 border-r-gray-200 border-b-gray-200 dark:border-t-gray-300 dark:border-r-gray-300 dark:border-b-gray-300`}
        style={{
          animationDirection: 'reverse',
          animationDuration: '0.8s'
        }}
      ></div>
    </div>
  )
}
